import { render, staticRenderFns } from "./CreateReceivableAccount.vue?vue&type=template&id=d9689c0a&"
import script from "./CreateReceivableAccount.vue?vue&type=script&lang=js&"
export * from "./CreateReceivableAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports